import { useQuery } from '@tanstack/react-query';

import type { AdminUser } from 'app/typings';
import { apiRequest } from 'app/utils/request/api';

const path = '/admin/users/admins' as const;

export function useAdminUser() {
  return useQuery({
    queryKey: [path],
    queryFn: () => apiRequest({ path }) as Promise<AdminUser[]>,
    staleTime: Infinity,
  });
}
